import { render } from "./PublicPortalView.vue?vue&type=template&id=40c925a1&scoped=true"
import script from "./PublicPortalView.vue?vue&type=script&lang=js"
export * from "./PublicPortalView.vue?vue&type=script&lang=js"

import "./PublicPortalView.vue?vue&type=style&index=0&id=40c925a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c925a1"]])

export default __exports__